var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hhead'),_vm._v(" "),_c('nnav'),_vm._v(" "),_c('iframe',{staticClass:"iframe",style:({ width: '100%', height: _vm.heit, display: 'block' }),attrs:{"src":"/static/pages/html/home.html","frameborder":"0"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02d8215b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/user/ctp_user/view/index.vue
// module id = null
// module chunks = 